import SmartCropImage from "@/components/core/SmartCropImage"
import useSmartCrop from "@/hooks/useSmartCrop"
import { dataLayerForImageClick } from "@/components/Shared/VisualNav/analytics/index"
import { modifyHref } from "@/components/Shared/HeaderNavTabs/utils"
import { authorBaseUrl } from "@/constants/index"
import htmlParser from "html-react-parser"

const FilterComponent = ({
  data = {},
  index = -1,
  productLength = 0,
  onNavSelection = () => {},
  isSlected = false,
}) => {
  const {
    visualNavType = "",
    imageAltText = "",
    filterValue = "",
    imageUrl = "",
    filterName = "",
    title = "",
    link = "",
    newTab = false,
  } = data

  const onFilterClick = () => {
    onNavSelection(index, filterName, filterValue)
    !isSlected
      ? sessionStorage.setItem("filterName", filterValue)
      : sessionStorage.removeItem("filterName")
    dataLayerForImageClick({
      isSlected,
      index,
      productLength,
      title,
      imageUrl,
    })
  }

  const readyUrl = imageUrl?.startsWith("/content/dam")
    ? `${authorBaseUrl}${imageUrl}`
    : imageUrl
  const smartCrop = useSmartCrop()
  return visualNavType === "plpFilterNav" ? (
    <div className="imgesBlock" onClick={() => onFilterClick()}>
      <div className="filterImage">
        <SmartCropImage
          url={readyUrl}
          smartCrop={smartCrop}
          altText={imageAltText}
        />
      </div>
      <div className={`imageTitle${isSlected ? "-selected" : ""}`}>
        {htmlParser(title)}
      </div>
    </div>
  ) : (
    <a
      href={modifyHref(link)}
      target={newTab ? "_blank" : "_self"}
      rel="noreferrer"
    >
      <div
        className="imgesBlock"
        onClick={() =>
          dataLayerForImageClick({
            isSlected,
            index,
            productLength,
            title,
            imageUrl,
            link,
          })
        }
      >
        <div className="filterImage">
          <SmartCropImage
            url={readyUrl}
            smartCrop={smartCrop}
            altText={imageAltText}
          />
        </div>
        <div className="imageTitle">{htmlParser(title)}</div>
      </div>
    </a>
  )
}
export default FilterComponent
